import React, { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import CyberLoader from '../common/CyberLoader';
import ParticleBackground from '../common/ParticleBackground';
import './AuthScreen.css';

export default function AuthScreen({ onLogin }) {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
    const endpoint = isLogin ? '/api/auth/login' : '/api/auth/register';

    try {
      const resp = await fetch(`${baseUrl}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username,
          password,
          invite_code: !isLogin ? inviteCode : undefined,
        })
      });

      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(text || 'Authentication failed');
      }

      const data = await resp.json();
      localStorage.setItem('vault_jwt', data.token);
      localStorage.setItem('vault_username', data.username);
      onLogin(data.token, data.username);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <ParticleBackground />
      <motion.div 
        className="auth-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="auth-logo-wrapper">
           <img src="/assets/resources/The-Game-Vault.svg" alt="The Game Vault" className="auth-main-logo" />
        </div>

        <div className="auth-tabs">
          <button 
            type="button"
            className={`auth-tab ${isLogin ? 'active' : ''}`}
            onClick={() => { setIsLogin(true); setError(null); }}
          >
            Login
          </button>
          <button 
            type="button"
            className={`auth-tab ${!isLogin ? 'active' : ''}`}
            onClick={() => { setIsLogin(false); setError(null); }}
          >
            Register
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              required 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              required 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={isLogin ? "current-password" : "new-password"}
            />
          </div>

          <AnimatePresence>
            {!isLogin && (
              <motion.div 
                className="form-group"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                style={{ overflow: 'hidden' }}
              >
                <label>Secret Invite Code</label>
                <input 
                  type="text" 
                  required 
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value)}
                />
              </motion.div>
            )}
          </AnimatePresence>

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
            {loading ? <CyberLoader /> : (isLogin ? 'Enter Vault' : 'Create Access')}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
